import $ from 'jquery';
import 'daterangepicker';
import 'daterangepicker/daterangepicker.css';
import './dateRangePicker.css';
import moment from 'moment';
import 'moment/locale/cs';

moment.locale('cs');

const FMT_DATETIME = 'DD.MM.YYYY HH:mm';
const FMT_DATE = 'DD.MM.YYYY';

function parseValue(val) {
    if (!val) return null;
    for (const fmt of [FMT_DATETIME, FMT_DATE, 'YYYY-MM-DDTHH:mm', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD']) {
        const m = moment(val, fmt, true);
        if (m.isValid()) return m;
    }
    return null;
}

// Přidá k time pickeru šipky ±15 min a odkaz "Nyní".
// Šipky/"Nyní" volají helpery (adjustTime/setNow), které pracují přímo
// s modelem pickeru, ne přes DOM selecty — díky tomu se nezruší vícedenní rozpětí.
function addNowLinks(picker, helpers) {
    const { adjustTime, setNow } = helpers;
    picker.container[0].querySelectorAll('.calendar-time').forEach(calTime => {
        if (calTime.querySelector('.drp-now-link')) return;

        const drpCal = calTime.closest('.drp-calendar');
        const side = drpCal && drpCal.classList.contains('left') ? 'left' : 'right';

        const arrowStyle = 'font-size:0.6rem; text-decoration:none; user-select:none; line-height:1; display:block;';

        const upBtn = document.createElement('a');
        upBtn.href = '#';
        upBtn.className = 'drp-minute-arrow';
        upBtn.textContent = '▲';
        upBtn.title = '+15 minut';
        upBtn.style.cssText = arrowStyle;
        upBtn.addEventListener('click', (e) => { e.preventDefault(); adjustTime(side, 15); });

        const downBtn = document.createElement('a');
        downBtn.href = '#';
        downBtn.className = 'drp-minute-arrow';
        downBtn.textContent = '▼';
        downBtn.title = '-15 minut';
        downBtn.style.cssText = arrowStyle;
        downBtn.addEventListener('click', (e) => { e.preventDefault(); adjustTime(side, -15); });

        const link = document.createElement('a');
        link.href = '#';
        link.className = 'drp-now-link';
        link.textContent = 'Nyní';
        link.style.cssText = 'margin-left:8px; font-size:0.8rem; text-decoration:none;';
        link.addEventListener('click', (e) => { e.preventDefault(); setNow(side); });

        const arrowWrap = document.createElement('span');
        arrowWrap.style.cssText = 'display:inline-flex; flex-direction:column; align-items:center; margin-right:4px; vertical-align:middle;';
        arrowWrap.appendChild(upBtn);
        arrowWrap.appendChild(downBtn);

        calTime.appendChild(arrowWrap);
        calTime.appendChild(link);
    });
}

function createPicker(fromInput, toInput, fromDateInput, toDateInput, withTime) {
    // Zruš existující picker
    const existing = $(fromInput).data('daterangepicker');
    if (existing) existing.remove();
    $(fromInput).off('show.daterangepicker');
    // Odeber předchozí handlery ruční editace inputů (reinit při přepnutí allDay)
    if (fromInput._drpTextChange) fromInput.removeEventListener('change', fromInput._drpTextChange);
    if (toInput._drpTextChange) toInput.removeEventListener('change', toInput._drpTextChange);

    const fmt = withTime ? FMT_DATETIME : FMT_DATE;
    const startMoment = parseValue(fromInput.value) || moment().startOf('hour');
    const endMoment = parseValue(toInput.value) || moment().startOf('hour');

    // Zobraz hodnoty ve správném formátu
    fromInput.value = startMoment.format(fmt);
    toInput.value = endMoment.format(fmt);

    // Pokud je picker uvnitř Bootstrap modalu, použij modal-body jako parentEl,
    // aby focus trap modalu nezavíral nativní select dropdowny (hodiny/minuty)
    const modalBody = fromInput.closest('.modal-body');
    const parentEl = modalBody ? $(modalBody) : $('body');

    const getPicker = () => $(fromInput).data('daterangepicker');

    const writeToInputs = (start, end) => {
        if (withTime) {
            fromInput.value = start.format(FMT_DATETIME);
            toInput.value = end.format(FMT_DATETIME);
        } else {
            fromInput.value = start.format(FMT_DATE);
            toInput.value = end.format(FMT_DATE);
            if (fromDateInput) fromDateInput.value = start.format('YYYY-MM-DD');
            if (toDateInput) toDateInput.value = end.format('YYYY-MM-DD');
        }
    };

    const syncInputs = () => {
        const p = getPicker();
        if (!p) return;
        const start = p.startDate;
        const end = p.endDate && p.endDate.isValid() ? p.endDate : p.startDate;
        writeToInputs(start, end);
        // Aktualizuj i text "Od - Do" dole v pickeru
        p.container.find('.drp-selected').html(
            'od <strong>' + start.format(fmt) + '</strong> do <strong>' + end.format(fmt) + '</strong>'
        );
    };

    // Posun času o delta minut, drží stejný den (00:00..23:59)
    const shiftTime = (m, delta) => {
        const mins = Math.max(0, Math.min(23 * 60 + 59, m.hour() * 60 + m.minute() + delta));
        return m.clone().hour(Math.floor(mins / 60)).minute(mins % 60).second(0);
    };

    // Po změně Od nastav ČAS Do = čas Od + 30 min, ale DATUM Do zachovej
    // (aby zůstalo vícedenní rozpětí). Když by Do vyšlo před Od, srovnej ho na Od + 30 min.
    const bumpEndAfterStart = (p) => {
        const endMin = p.startDate.hour() * 60 + p.startDate.minute() + 30;
        let newEnd = p.endDate.clone().startOf('day').add(endMin, 'minutes');
        if (newEnd.isBefore(p.startDate)) newEnd = p.startDate.clone().add(30, 'minutes');
        p.setEndDate(newEnd);
    };

    // Šipky a "Nyní" mění čas přímo na modelu pickeru (ne přes DOM selecty),
    // takže vícedenní rozpětí zůstane zachované.
    const refreshAfterTime = (p) => {
        p.updateView();
        syncInputs();
        if (withTime) addNowLinks(p, helpers);
    };
    const adjustTime = (side, delta) => {
        const p = getPicker();
        if (!p) return;
        if (side === 'left') {
            p.setStartDate(shiftTime(p.startDate, delta));
            bumpEndAfterStart(p);
        } else {
            p.setEndDate(shiftTime(p.endDate, delta));
        }
        refreshAfterTime(p);
    };
    const setNow = (side) => {
        const p = getPicker();
        if (!p) return;
        const now = moment();
        if (side === 'left') {
            p.setStartDate(p.startDate.clone().hour(now.hour()).minute(now.minute()).second(0));
            bumpEndAfterStart(p);
        } else {
            p.setEndDate(p.endDate.clone().hour(now.hour()).minute(now.minute()).second(0));
        }
        refreshAfterTime(p);
    };
    const helpers = { adjustTime, setNow };

    $(fromInput).on('show.daterangepicker', (ev, picker) => {
        // Zakáže loading indicator na tlačítkách pickeru
        picker.container[0].querySelectorAll('.btn').forEach(btn => {
            btn.setAttribute('data-loading-indicator', 'false');
        });
        if (withTime) addNowLinks(picker, helpers);
        // Přepiš formát textu dole na "Od ... do ..."
        const start = picker.startDate;
        const end = picker.endDate && picker.endDate.isValid() ? picker.endDate : picker.startDate;
        picker.container.find('.drp-selected').html(
            'od <strong>' + start.format(fmt) + '</strong> do <strong>' + end.format(fmt) + '</strong>'
        );
        // Přidej nápovědu pod tlačítka (jen jednou)
        if (!picker.container[0].querySelector('.drp-hint')) {
            const hint = document.createElement('div');
            hint.className = 'drp-hint';
            hint.innerHTML =
                '<span>Pro výběr jednoho konkrétního dne klikněte dvakrát na vybraný den</span>' +
                '<span>Pro výběr více dnů klikněte jednou na počáteční den a poté jednou na koncový den</span>';
            picker.container.find('.drp-buttons')[0].appendChild(hint);
        }
    });

    $(fromInput).daterangepicker({
        timePicker: withTime,
        timePicker24Hour: true,
        startDate: startMoment,
        endDate: endMoment,
        locale: {
            format: fmt,
            applyLabel: 'Potvrdit',
            cancelLabel: 'Zrušit',
            fromLabel: 'Od',
            toLabel: 'Do',
            weekLabel: 'T',
            daysOfWeek: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
            monthNames: ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen',
                'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec'],
            firstDay: 1,
        },
        opens: 'right',
        drops: 'down',
        autoUpdateInput: false,
        parentEl: parentEl,
    }, (start, end) => writeToInputs(start, end));

    // Vypni interní parsování inputu Od daterangepickerem (čeká formát "start - end" v jednom poli) — řešíme vlastními handlery
    $(fromInput).off('keyup.daterangepicker change.daterangepicker');

    // Real-time propisy při výběru datumu a změně času — bez čekání na "Potvrdit"
    const picker = getPicker();
    if (picker) {
        // Ruční editace inputu Od (text) → nastav start a Do = Od + 30 min (jen u jednodenního výběru)
        const applyFromText = () => {
            const m = parseValue(fromInput.value);
            if (!m) return;
            picker.setStartDate(m);
            bumpEndAfterStart(picker);
            if (withTime) {
                picker.renderTimePicker('left');
                picker.renderTimePicker('right');
                addNowLinks(picker, helpers);
            }
            syncInputs();
        };
        fromInput._drpTextChange = applyFromText;
        fromInput.addEventListener('change', applyFromText);

        // Ruční editace inputu Do (text) → nastav jen konec
        const applyToText = () => {
            const m = parseValue(toInput.value);
            if (!m) return;
            picker.setEndDate(m);
            if (withTime) {
                picker.renderTimePicker('right');
                addNowLinks(picker, helpers);
            }
            syncInputs();
        };
        toInput._drpTextChange = applyToText;
        toInput.addEventListener('change', applyToText);

        // mouseup fires AFTER mousedown (který jQuery zpracoval interně → startDate/endDate jsou aktuální)
        picker.container[0].addEventListener('mouseup', (e) => {
            if (e.target.closest('td.available')) {
                syncInputs();
                // Výběr data interně přerenderuje time picker → znovu přidej šipky a "Nyní"
                if (withTime) addNowLinks(picker, helpers);
            }
        });

        // Změna času v levém kalendáři (Od) → vždy nastav Do = Od + 30 min.
        // Daterangepicker bindí change handler na .drp-calendar (NE na container!),
        // takže unbind/rebind musí cílit taky na .drp-calendar.
        if (withTime) {
            const drpCals = picker.container.find('.drp-calendar');
            drpCals.off('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect');
            drpCals.on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', function (e) {
                const isLeft = $(e.target).closest('.drp-calendar').hasClass('left');
                picker.timeChanged(e);
                if (isLeft) {
                    bumpEndAfterStart(picker);
                    picker.updateView();
                }
                syncInputs();
                // updateView/renderTimePicker přepíše obsah .calendar-time → znovu přidej šipky a "Nyní"
                addNowLinks(picker, helpers);
            });
        }
    }
}

function initDateRangePickers() {
    document.querySelectorAll('[data-range-picker="from"]').forEach(fromContainer => {
        const fromInput = fromContainer.querySelector('input');
        if (!fromInput || fromInput.dataset.drpInit) return;

        const row = fromContainer.closest('.row');
        if (!row) return;

        const toContainer = row.querySelector('[data-range-picker="to"]');
        const toInput = toContainer?.querySelector('input');
        if (!toInput) return;

        fromInput.dataset.drpInit = '1';
        toInput.dataset.drpInit = '1';

        // Přepis typu na text
        const fromRaw = fromInput.value;
        const toRaw = toInput.value;
        fromInput.setAttribute('type', 'text');
        toInput.setAttribute('type', 'text');
        fromInput.value = fromRaw;
        toInput.value = toRaw;

        // Skrytá datová pole pro allDay — hledáme v nejbližším společném kontejneru (td, form)
        const container = fromContainer.closest('td') || fromInput.closest('form');
        const form = fromInput.closest('form');
        const fromDateInput = (container?.querySelector('[data-range-picker="fromDate"] input'))
            ?? form?.querySelector('[data-range-picker="fromDate"] input');
        const toDateInput = (container?.querySelector('[data-range-picker="toDate"] input'))
            ?? form?.querySelector('[data-range-picker="toDate"] input');

        // allDay checkbox — hledáme nejdřív ve stejném .row, pak v kontejneru
        const allDayInput = row.querySelector('input[name*="allDay"]')
            ?? container?.querySelector('input[name*="allDay"]')
            ?? form?.querySelector('input[name*="allDay"]');
        const isAllDay = () => allDayInput?.checked ?? false;

        // Inicializace
        createPicker(fromInput, toInput, fromDateInput, toDateInput, !isAllDay());

        // Klik/focus na "Do" otevře kalendář a zároveň Do zůstane ručně editovatelné.
        // stopPropagation u focusin zabrání, aby daterangepicker popup hned zavřel
        // (jinak bere focus na poli Do jako kliknutí mimo a zavře ho).
        toInput.addEventListener('focusin', (e) => e.stopPropagation());
        toInput.addEventListener('focus', () => {
            $(fromInput).data('daterangepicker')?.show();
        });

        // Přepnutí allDay → reinicializace pickeru bez/s časem
        if (allDayInput) {
            allDayInput.addEventListener('change', () => {
                createPicker(fromInput, toInput, fromDateInput, toDateInput, !isAllDay());
            });
        }
    });
}

export default initDateRangePickers;
